import { IApplicationData } from "../../model/application-data";

// Ambiente de desenvolvimento: em localhost o módulo e o multitenant não vêm do domínio,
// são escolhidos na tela de seleção e guardados no localStorage.

export interface ILocalModule {
    moduleId: number;
    moduleName: string;
    moduleDescription: string;
    baseUrl: string;
}

export interface ILocalTenant {
    multitenant: number;
    name: string;
}

export interface ILocalEnvironment {
    moduleId: number;
    multitenant: number;
    baseUrl: string;
    baseUrlAuthentication: string;
}

export const localModules: ILocalModule[] = [
    { moduleId: 1, moduleName: "SDP", moduleDescription: "Diagramação e Publicação", baseUrl: "http://localhost:5052/" },
    { moduleId: 2, moduleName: "SER", moduleDescription: "Envio de Remessas", baseUrl: "http://localhost:5058/" },
    { moduleId: 7, moduleName: "OUV", moduleDescription: "Ouvidoria", baseUrl: "http://localhost:5059/" },
    { moduleId: 3, moduleName: "APM", moduleDescription: "Gestão de Portal da Entidade", baseUrl: "http://localhost:5200/" },
    { moduleId: 9, moduleName: "SCP", moduleDescription: "Contratações Públicas", baseUrl: "http://localhost:5071/" },
    { moduleId: 10, moduleName: "SGE", moduleDescription: "Emendas Parlamentares", baseUrl: "http://localhost:5195/" },
];

export const localTenants: ILocalTenant[] = [
    { multitenant: 7, name: "IPMBRASIL" },
    { multitenant: 3851, name: "DOCGED SISTEMAS" },
    { multitenant: 3901, name: "AIRDOC" },
];

export const defaultLocalAuthenticationUrl = "http://localhost:5186/";

const storageKey = "local_environment";

const isLocalhost = (): boolean => window.location.hostname.toLowerCase().includes("localhost");

const get = (): ILocalEnvironment | undefined => {
    try {
        const value = localStorage.getItem(storageKey);
        const environment = value ? (JSON.parse(value) as ILocalEnvironment) : undefined;
        return environment && localModules.some(m => m.moduleId === environment.moduleId) ? environment : undefined;
    } catch {
        return undefined;
    }
};

const set = (environment: ILocalEnvironment) => {
    localStorage.setItem(storageKey, JSON.stringify(environment));
};

const clear = () => {
    localStorage.removeItem(storageKey);
};

const needsSelection = (): boolean => isLocalhost() && !get();

const getModule = (moduleId: number) => localModules.find(m => m.moduleId === moduleId);

const getTenant = (multitenant: number) => localTenants.find(t => t.multitenant === multitenant);

const getApplicationData = (): IApplicationData => {
    const environment = get();
    const module = environment ? getModule(environment.moduleId) : undefined;

    if (!environment || !module) {
        return {} as IApplicationData;
    }

    return {
        multitenant: environment.multitenant,
        moduleId: module.moduleId,
        moduleName: module.moduleName,
        moduleDescription: module.moduleDescription,
        baseUrl: environment.baseUrl,
        baseUrlAuthentication: environment.baseUrlAuthentication,
        initialPage: "dashboard",
    } as IApplicationData;
};

const LocalEnvironment = {
    isLocalhost, get, set, clear, needsSelection, getModule, getTenant, getApplicationData
};

export default LocalEnvironment;
